import React from 'react';
import { createRoot } from 'react-dom/client';
import './theme/custom.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import logger from './utils/logger';
import { Provider } from 'react-redux';
import store from './redux/store';
logger.configure({
  auth: true,
  api: true,
  ui: false,
});

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

reportWebVitals();
